import { useContext, useState } from "react";
import "./Color.css"
import { ModalContext } from "../../../context";
import { createPortal } from "react-dom";
import { APCA } from "./APCA/APCA";

export const Color = ({item, size = 'm'}) => {
    const [copied, setCopied] = useState(false);
	const [openAPCA, setOpenAPCA] = useState(false);
	const [modal, toggleModal] = useContext(ModalContext)

    const copy = color => {
        window.navigator.clipboard.writeText(color.toUpperCase());
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2500);
    }

	const toggleAPCA = () => {
		setOpenAPCA(!openAPCA)
		toggleModal()
	}

	if (size === 'xs') {
		return (<div className="color color--xs">
			<div
				className="color__swatch"
				style={{"--color": item.value}}
				aria-label={item.name}
			></div>
		</div>)
	}

	if (size === 's') {
		return (<div className="color color--s">
			<div
				className={`color__swatch ${copied ? "color__swatch--copied" : ""}`}
				style={{"--color": item.value}}
				onClick={() => copy(item.value)}
				aria-label={item.name}
			></div>
		</div>)
	}

    return (<div className="color">
        <button
            className={`color__swatch ${copied ? "color__swatch--copied" : ""}`}
            style={{"--color": item.value}}
            onClick={() => copy(item.value)}
        >
			<span className="color__swatch-label">Kopieer</span>
		</button>
		<div className="color__info">
			<h3 className="color__name">
				{item.name}
			</h3>
			<p className="color__hex">{item.value.toUpperCase()}</p>
			<button className="color__contrast" onClick={toggleAPCA}>
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
					<title>Contrast</title>
					<path d="M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/>
				</svg>
			</button>
		</div>
		{openAPCA && createPortal(<>
			<div className="modal__title">
				<h3>Contrast</h3>
				<button className="modal__close" onClick={toggleAPCA}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="30" height="30">
						<title>Sluiten</title>
						<path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
					</svg>
				</button>
			</div>
			<APCA color={item}></APCA>
		</>, modal.current) }
    </div>);
}
